export default __webpack_public_path__ + "static/media/launchIcon.069f0ce6.svg";